/* unplugin-vue-components disabled */import { render } from "./insManageBonus.vue?vue&type=template&id=4ea3f2f4&scoped=true"
import script from "./insManageBonus.vue?vue&type=script&lang=js"
export * from "./insManageBonus.vue?vue&type=script&lang=js"

import "./insManageBonus.vue?vue&type=style&index=0&id=4ea3f2f4&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea3f2f4"]])

export default __exports__